import ProductImage from "../ProductTile/ProductImage";
import LazyProductImage from "../../containers/LazyProductImage";

const initialImageLoadCount = 4;

const getProductImageComponent = ({ isInitialPage, index }) =>
  isInitialPage && index < initialImageLoadCount
    ? ProductImage
    : LazyProductImage;

export default getProductImageComponent;
